import Bridge from 'src/frontend-lib/lib/Bridge.js'
import { getEnvHost, getPlatform } from 'src/frontend-lib/tools/getPlatform'

// 读书会组件
export default class BookListComponent {
  constructor() {
    this.$platform = getPlatform()
    this.$bridge = new Bridge()
    this.pending = false
    this.listenBookEvents()
  }

  // 点击书籍进行跳转
  listenBookEvents() {
    const $books = document.querySelectorAll(
      '.js-book-list-wrap .js-newClassitem-wrap'
    )
    for (let i = 0; i < $books.length; i++) {
      const $book = $books[i]
      $book.addEventListener('click', event => {
        const target = event.currentTarget
        const id = target.dataset.id
        if (id) {
          const staticSite = getEnvHost('static.xinli001.com')
          this.goPage(
            `https://${staticSite}/kc/index.html?init=3&channelId=522#/bookdetail/${id}?channelId=522`
          )
        } else {
          window.toast('书籍id不存在！')
        }
      })
    }
  }

  // 获取最近的祖先节点（包含clsName类）
  getClosestParent(clsName, el) {
    if (!clsName || !el) return null
    let parent = el.parentNode
    while (parent && parent !== document.body) {
      if (parent.classList.contains(clsName)) {
        return parent
      }
      parent = parent.parentNode
    }
    return null
  }

  goPage(url) {
    if (this.$platform.isYixinliApp) {
      this.$bridge.call('openWebView', {
        url,
        isCurrentPageOpen: 0
      })
    } else {
      window.location.href = url
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/promotion/template/js/BookListComponent.js